import React from "react";
import { Form, Image } from "react-bootstrap";
import classnames from "classnames";
import Switch from "react-switch";
import { TopTextReusableComponent } from "../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import { InputBoxComponent } from "../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { ReservationTimeModel } from "../../../reusableOnboardingPopupComponent/ReservationTimeModel";
import { ReusableOnboardingButton } from "../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import RightSidePannel from "../../rightSidePannelReusable/RightSidePannel";
import InputNumberFunc from "../../../../../function/InputNumberFunc";

export const ReservationScreen = ({
  state,
  errors,
  onReservationChangeHandler,
  onChange,
  onFocusOut,
  reservationTableKeptOpen,
  reservationTableKeptClosed,
  reservationTableKeptButtonClick,
  sameDayAllowed,
  reservationMinLeadOpen,
  reservationMinLeadClosed,
  reservationMinLeadTimeButtonClick,
  reservationCutOffTimeOpen,
  reservationCutOffTimeClosed,
  reservationCutOffTimeButtonClick,
  reservationTimeSlotsOpen,
  reservationTimeSlotsClosed,
  reservationTimeSlotsButtonClick,
  onReservationSubmit,
}) => {
  return (
    <React.Fragment>
      <div className="col-12 onboarding-back-button-all-screen">
        <div className="back_button-link" onClick={onReservationChangeHandler}>
          <Image
            src={require("../../../../../assets/images/Icon/onBoardBack.png")}
            alt="Back Button"
            title="Back Button"
          />
        </div>
      </div>
      <div className="display-toggle-stepup-button">
        <RightSidePannel selectedTab={4} />
      </div>
      <div className="subscription-reservaton-screen-section">
        <TopTextReusableComponent headingText="Reservation Settings" />
        <div className="subscription-reservation-section-one">
          <h4>Settings for Reservation</h4>
          <div className="col-12">
            <div className="row align-items-center reservation-mobile-device-bottom">
              <div className="col-8 col-sm-8 col-md-6 col-lg-5 col-xl-5 pl-0">
                <div className="top-seating-area-heading">
                  <h4 className="big-heading-text m-0">Minimum Person</h4>
                </div>
              </div>
              <div className="col-4 col-sm-4 col-md-6 col-lg-4 col-xl-4 pr-0">
                <div>
                  <div className="position-relative">
                    <InputBoxComponent
                      displayLabel={false}
                      controlId="minimumPersonReservation"
                      placeHolder="eg. 1*"
                      min="1"
                      max="99"
                      maxLength="2"
                      name="minimumPersonReservation"
                      inputType="number"
                      onChange={onChange}
                      onFocusOut={onFocusOut}
                      value={state.minimumPersonReservation}
                      onKeyDown={InputNumberFunc}
                      required="required"
                      // error={errors.minimumPersonReservation}
                      inputClassName={classnames(
                        "input-component-inputfield text-center pr-4",
                        {
                          invalid: errors.minimumPersonReservation,
                        }
                      )}
                    />
                    <p className="small-bottom-text-input-seatingarea">pax</p>
                    <Form.Text className="w-100 text-muted text-center input-component-bottom position-absolute">
                      <div className="text-danger text-capitalize">
                        {errors.minimumPersonReservation ===
                        "minimumPersonReservation is required"
                          ? "minimum person reservation is required"
                          : null}
                      </div>
                    </Form.Text>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 subscription_main_error_margin-two">
            <div className="row align-items-center reservation-mobile-device-bottom mt-4">
              <div className="col-8 col-sm-8 col-md-6 col-lg-5 col-xl-5 pl-0">
                <div className="top-seating-area-heading">
                  <h4 className="big-heading-text m-0">Table is kept for</h4>
                  <p className="small-heading-text">
                    (Table is kept for stipulated time and cancelled)
                  </p>
                </div>
              </div>
              <div className="col-4 col-sm-4 col-md-6 col-lg-4 col-xl-4 pr-0">
                <div>
                  <div className="position-relative">
                    <div onClick={reservationTableKeptOpen}>
                      <InputBoxComponent
                        displayLabel={false}
                        controlId="reservationTableKeptFor"
                        placeHolder="Select*"
                        // min="1"
                        // max="99"
                        name="reservationTableKeptFor"
                        inputType="number"
                        onChange={onChange}
                        value={state.reservationTableKeptFor}
                        required="required"
                        disabled={true}
                        // error={errors.reservationTableKeptFor}
                        inputClassName={classnames(
                          "input-component-inputfield text-center pr-4",
                          {
                            invalid: errors.reservationTableKeptFor,
                          }
                        )}
                      />
                    </div>
                    <p className="small-bottom-text-input-seatingarea">min</p>
                    <Form.Text className="w-100 text-muted text-center input-component-bottom position-absolute">
                      <div className="text-danger text-capitalize">
                        {state.reservationTableKeptFor === "" &&
                        state.resTabKeptForError === true
                          ? "Table is kept for required"
                          : null}
                      </div>
                    </Form.Text>
                    <ReservationTimeModel
                      onOpenModal={reservationTableKeptOpen}
                      open={state.reservationTableKeptForPopup}
                      onCloseModal={reservationTableKeptClosed}
                      buttonTitle="Table is kept for"
                      buttonText="Table is kept for"
                      headerText="Table is kept for"
                      displayButtonThree={true}
                      timeTextOne="00 &nbsp;&nbsp; Minutes"
                      timeTextTwo="05 &nbsp;&nbsp; Minutes"
                      timeTextThree="10 &nbsp;&nbsp; Minutes"
                      timeTextFour="15 &nbsp;&nbsp; Minutes"
                      timeTextFive="20 &nbsp;&nbsp; Minutes"
                      timeTextSix="30 &nbsp;&nbsp; Minutes"
                      timeOneClick={(e) =>
                        reservationTableKeptButtonClick(e, "00")
                      }
                      timeTwoClick={(e) =>
                        reservationTableKeptButtonClick(e, "05")
                      }
                      timeThreeClick={(e) =>
                        reservationTableKeptButtonClick(e, "10")
                      }
                      timeFourClick={(e) =>
                        reservationTableKeptButtonClick(e, "15")
                      }
                      timeFiveClick={(e) =>
                        reservationTableKeptButtonClick(e, "20")
                      }
                      timeSixClick={(e) =>
                        reservationTableKeptButtonClick(e, "30")
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="reservation-toggle-button">
            <div className="top-seating-area-heading">
              <h4 className="big-heading-text m-0">
                Reservation - Same Day Allowed?
              </h4>
              <p className="small-heading-text">
                (Last Reservation as per the Reservation Time slot below, Nois
                at closing time)
              </p>
            </div>
            <div className="d-flex align-items-center">
              <p
                className={
                  state.sameDayAllowed === false
                    ? "toggleclass-button-yes-no-button-active"
                    : "toggleclass-button-yes-no-button"
                }
              >
                No
              </p>
              <Switch
                checked={state.sameDayAllowed}
                onChange={sameDayAllowed}
                onColor="#59f832"
                onHandleColor="#ffffff"
                handleDiameter={23}
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                height={26}
                width={55}
                className="toggle-button-margin"
                id="material-switch"
              />
              <p
                className={
                  state.sameDayAllowed === false
                    ? "toggleclass-button-yes-no-button"
                    : "toggleclass-button-yes-no-button-active"
                }
              >
                Yes
              </p>
            </div>
          </div>
          {state.sameDayAllowed ? (
            <div className="col-12 subscription_main_error_margin-two">
              <div className="row align-items-center mb-4">
                <div className="col-7 col-sm-7 col-md-5 col-lg-5 col-xl-5 pl-0">
                  <div className="top-seating-area-heading">
                    <h4 className="big-heading-text m-0">Minimum Lead Time</h4>
                    <p className="small-heading-text">
                      (Minimum lead time Reservation is to be made)
                    </p>
                  </div>
                </div>
                <div className="col-5 col-sm-5 col-md-4 col-lg-4 col-xl-4 pr-0">
                  <div>
                    <div className="position-relative">
                      <div onClick={reservationMinLeadOpen}>
                        <InputBoxComponent
                          displayLabel={false}
                          controlId="reservationMinLeadTime"
                          placeHolder="Select*"
                          name="reservationMinLeadTime"
                          inputType="text"
                          onChange={onChange}
                          value={state.reservationMinLeadTime}
                          required="required"
                          disabled={true}
                          error={errors.reservationMinLeadTime}
                          inputClassName={classnames(
                            "input-component-inputfield text-center pr-4",
                            {
                              invalid: errors.reservationMinLeadTime,
                            }
                          )}
                        />
                      </div>
                      <p className="small-bottom-text-input-seatingarea">Hrs</p>
                      <Form.Text className="w-100 text-muted text-center input-component-bottom position-absolute">
                        <div className="text-danger text-capitalize">
                          {state.reservationMinLeadTime === "" &&
                          state.resMinLeadTimeError === true
                            ? "Minimum Lead Time Is Required"
                            : null}
                        </div>
                      </Form.Text>
                      <ReservationTimeModel
                        onOpenModal={reservationMinLeadOpen}
                        open={state.reservationMinLead}
                        onCloseModal={reservationMinLeadClosed}
                        displayButtonThree={true}
                        buttonTitle="Reservation Min Lead"
                        buttonText="Reservation Min Lead"
                        headerText="Reservation Min Lead"
                        timeTextOne="00 &nbsp;&nbsp; Hrs"
                        timeTextTwo="0.5 &nbsp;&nbsp; Hrs"
                        timeTextThree="01 &nbsp;&nbsp; Hrs"
                        timeTextFour="02 &nbsp;&nbsp; Hrs"
                        timeTextFive="03 &nbsp;&nbsp; Hrs"
                        timeTextSix="04 &nbsp;&nbsp; Hrs"
                        timeOneClick={(e) =>
                          reservationMinLeadTimeButtonClick(e, "00")
                        }
                        timeTwoClick={(e) =>
                          reservationMinLeadTimeButtonClick(e, "0.5")
                        }
                        timeThreeClick={(e) =>
                          reservationMinLeadTimeButtonClick(e, "01")
                        }
                        timeFourClick={(e) =>
                          reservationMinLeadTimeButtonClick(e, "02")
                        }
                        timeFiveClick={(e) =>
                          reservationMinLeadTimeButtonClick(e, "03")
                        }
                        timeSixClick={(e) =>
                          reservationMinLeadTimeButtonClick(e, "04")
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          {/* /*****************************
             @DESC Minimum Lead Time
             *******************************/}
          <div className="col-12 subscription_main_error_margin-two">
            <div className="row align-items-center mb-4">
              <div className="col-7 col-sm-7 col-md-6 col-lg-5 col-xl-5 pl-0">
                <div className="top-seating-area-heading">
                  <h4 className="big-heading-text m-0">
                    Cut Off Time - Reservation
                  </h4>
                  <p className="small-heading-text">
                    (Last Reservation as per the Reservation Time slot below, No
                    is at closing time)
                  </p>
                </div>
              </div>
              <div className="col-5 col-sm-5 col-md-6 col-lg-4 col-xl-4 pr-0">
                <div>
                  <div className="position-relative">
                    <div onClick={reservationCutOffTimeOpen}>
                      <InputBoxComponent
                        displayLabel={false}
                        controlId="reservationCutOffTimeText"
                        placeHolder="Select*"
                        name="reservationCutOffTimeText"
                        inputType="text"
                        onChange={onChange}
                        value={state.reservationCutOffTimeText}
                        required="required"
                        disabled={true}
                        error={errors.reservationCutOffTimeText}
                        inputClassName={classnames(
                          "input-component-inputfield text-center pr-4",
                          {
                            invalid: errors.reservationCutOffTimeText,
                          }
                        )}
                      />
                    </div>
                    <p className="small-bottom-text-input-seatingarea">
                      Minutes
                    </p>
                    <Form.Text className="w-100 text-muted text-center input-component-bottom position-absolute">
                      <div className="text-danger text-capitalize">
                        {state.reservationCutOffTimeText === "" &&
                        state.resCutOffTimeError === true
                          ? "Cut Off Time Is Required"
                          : null}
                      </div>
                    </Form.Text>
                    <ReservationTimeModel
                      onOpenModal={reservationCutOffTimeOpen}
                      open={state.reservationCutOffTime}
                      onCloseModal={reservationCutOffTimeClosed}
                      buttonTitle="Reservation Cut Off"
                      buttonText="Reservation Cut Off"
                      headerText="Reservation Cut Off"
                      timeTextOne="00 &nbsp;&nbsp; Minutes"
                      timeTextTwo="15 &nbsp;&nbsp; Minutes"
                      timeTextThree="30 &nbsp;&nbsp; Minutes"
                      timeTextFour="60 &nbsp;&nbsp; Minutes"
                      timeOneClick={(e) =>
                        reservationCutOffTimeButtonClick(e, "00")
                      }
                      timeTwoClick={(e) =>
                        reservationCutOffTimeButtonClick(e, "15")
                      }
                      timeThreeClick={(e) =>
                        reservationCutOffTimeButtonClick(e, "30")
                      }
                      timeFourClick={(e) =>
                        reservationCutOffTimeButtonClick(e, "60")
                      }
                      displayButtonTwo={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* /*****************************
             @DESC Maximum Days ahead
             *******************************/}
          <div className="col-12 subscription_main_error_margin-two">
            <div className="row align-items-center">
              <div className="col-7 col-sm-7 col-md-6 col-lg-5 col-xl-5 pl-0">
                <div className="top-seating-area-heading">
                  <h4 className="big-heading-text m-0">Maximum Days ahead</h4>
                  <p className="small-heading-text">
                    (Maximum time ahead Reservation can be made)
                  </p>
                </div>
              </div>
              <div className="col-5 col-sm-5 col-md-6 col-lg-4 col-xl-4 pr-0">
                <div>
                  <div className="position-relative">
                    <InputBoxComponent
                      displayLabel={false}
                      controlId="maximumDays"
                      placeHolder="eg. 180*"
                      min="0"
                      max="180"
                      maxLength="3"
                      name="maximumDays"
                      inputType="number"
                      onKeyDown={InputNumberFunc}
                      onChange={onChange}
                      onFocusOut={onFocusOut}
                      value={state.maximumDays}
                      required="required"
                      // error={errors.maximumDays}
                      inputClassName={classnames(
                        "input-component-inputfield text-center pr-4",
                        {
                          invalid: errors.maximumDays,
                        }
                      )}
                    />
                    <p className="small-bottom-text-input-seatingarea">Days</p>
                    <Form.Text className="w-100 text-muted text-center input-component-bottom position-absolute">
                      <div className="text-danger text-capitalize">
                        {errors.maximumDays === "maximumDays is required"
                          ? "Maximum Days Is Required"
                          : null}
                      </div>
                    </Form.Text>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* /*****************************
             @DESC Reservation Capacity
             *******************************/}
          <div className="col-12 subscription_main_error_margin-two">
            <div className="row align-items-center">
              <div className="col-7 col-sm-7 col-md-6 col-lg-5 col-xl-5 pl-0">
                <div className="top-seating-area-heading">
                  <h4 className="big-heading-text m-0">Reservation Capacity</h4>
                  <p className="small-heading-text">
                    ( How much of Seating capacity can be reserved)
                  </p>
                </div>
              </div>
              <div className="col-5 col-sm-5 col-md-6 col-lg-4 col-xl-4 pr-0">
                <div>
                  <div className="position-relative">
                    <InputBoxComponent
                      displayLabel={false}
                      controlId="reservationCapacity"
                      placeHolder="eg. 10 %*"
                      min="0"
                      max="100"
                      maxLength="3"
                      name="reservationCapacity"
                      inputType="number"
                      onKeyDown={InputNumberFunc}
                      onChange={onChange}
                      onFocusOut={onFocusOut}
                      value={state.reservationCapacity}
                      required="required"
                      // error={errors.reservationCapacity}
                      inputClassName={classnames(
                        "input-component-inputfield text-center pr-4",
                        {
                          invalid: errors.reservationCapacity,
                        }
                      )}
                    />
                    <p className="small-bottom-text-input-seatingarea">%</p>
                    <Form.Text className="w-100 text-muted text-center input-component-bottom position-absolute">
                      <div className="text-danger text-capitalize">
                        {errors.reservationCapacity ===
                        "reservationCapacity is required"
                          ? "Reservation Capacity Is Required"
                          : null}
                      </div>
                    </Form.Text>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* /*****************************
             @DESC Reservation Time Slot
             *******************************/}
          <div className="col-12 subscription_main_error_margin-two">
            <div className="row align-items-center margin-bottom-chains-onboarding mb-5 mt-5">
              <div className="col-7 col-sm-7 col-md-6 col-lg-5 col-xl-5 pl-0">
                <div className="top-seating-area-heading">
                  <h4 className="big-heading-text m-0">
                    Reservation Time Slot
                  </h4>
                  <p className="small-heading-text">
                    Users will be given slots in these intervals to make
                    reservation request during open hours)
                  </p>
                </div>
              </div>
              <div className="col-5 col-sm-5 col-md-6 col-lg-4 col-xl-4 pr-0">
                <div>
                  <div className="position-relative">
                    <div onClick={reservationTimeSlotsOpen}>
                      <InputBoxComponent
                        displayLabel={false}
                        controlId="reservationTimeSlotsText"
                        placeHolder="Select*"
                        name="reservationTimeSlotsText"
                        inputType="text"
                        onChange={onChange}
                        onFocusOut={onFocusOut}
                        value={state.reservationTimeSlotsText}
                        required="required"
                        disabled={true}
                        error={errors.reservationTimeSlotsText}
                        inputClassName={classnames(
                          "input-component-inputfield text-center pr-4",
                          {
                            invalid: errors.reservationTimeSlotsText,
                          }
                        )}
                      />
                    </div>
                    <p className="small-bottom-text-input-seatingarea">
                      Minutes
                    </p>
                    <Form.Text className="w-100 text-muted text-center input-component-bottom position-absolute">
                      <div className="text-danger text-capitalize">
                        {state.reservationTimeSlotsText === "" &&
                        state.resTimeSlotError === true
                          ? "Reservation Time Slot Is Required"
                          : null}
                      </div>
                    </Form.Text>
                    <ReservationTimeModel
                      onOpenModal={reservationTimeSlotsOpen}
                      open={state.reservationTimeSlots}
                      onCloseModal={reservationTimeSlotsClosed}
                      buttonTitle="Reservation Time Slots"
                      buttonText="Reservation Time Slots"
                      headerText="Reservation Time Slots"
                      timeTextOne="15 &nbsp;&nbsp; Minutes"
                      timeTextTwo="30 &nbsp;&nbsp; Minutes"
                      timeTextThree="60 &nbsp;&nbsp; Minutes"
                      displayButton={true}
                      displayButtonTwo={true}
                      timeOneClick={(e) =>
                        reservationTimeSlotsButtonClick(e, "15")
                      }
                      timeTwoClick={(e) =>
                        reservationTimeSlotsButtonClick(e, "30")
                      }
                      timeThreeClick={(e) =>
                        reservationTimeSlotsButtonClick(e, "60")
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="onboarding-map-setup-screen-autodetect-button">
            <ReusableOnboardingButton
              buttonTitle="Back Button"
              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
              buttonText="Back"
              onClick={onReservationChangeHandler}
            />
            <ReusableOnboardingButton
              buttonTitle="Next Button"
              buttonClass={
                state.minimumPersonReservation < 1 ||
                state.reservationTableKeptFor === "" ||
                state.reservationCutOffTimeText === "" ||
                state.maximumDays.length <= 1 ||
                state.reservationCapacity.length <= 1 ||
                state.reservationTimeSlotsText === ""
                  ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray ml-3"
                  : "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
              }
              disabled={
                state.minimumPersonReservation < 1 ||
                state.reservationTableKeptFor === "" ||
                state.reservationCutOffTimeText === "" ||
                state.maximumDays.length <= 1 ||
                state.reservationCapacity.length <= 1 ||
                state.reservationTimeSlotsText === ""
                  ? true
                  : false
              }
              buttonText="Next"
              buttonType="submit"
              onClick={onReservationSubmit}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ReservationScreen;
